import { Flex,HStack, Progress, Text, VStack,Field } from "@chakra-ui/react";
import useApi from "../function/useApi";
import { useEffect, useState } from "react";

import { Separator,Button,Dialog, Portal,CloseButton, Input, Link } from "@chakra-ui/react"

import { useDispatch } from "react-redux";
import { userContextAction } from "../store/UserContext";
const Tagihan = ()=>{
    const { responses, loading, error, fetchData } = useApi();
    const [cycleData, setCycleData] = useState([]);
    const dispatch = useDispatch();
    useEffect(()=>{
        fetchData('cycle',`${process.env.REACT_APP_API_URL}?data=cycle`);
        const interval = setInterval(fetchData, 2700000);
        return () => clearInterval(interval);
    },[]);


        useEffect(()=>{
            if(loading?.cycle){
                dispatch(userContextAction.loadingOn())
            }else{
                dispatch(userContextAction.loadingOff())
            }
        },[loading?.cycle]);

    useEffect(()=>{
        if(responses?.cycle){
            const data = responses.cycle.sort((a, b) => b.total_cost - a.total_cost);
            setCycleData(data);
        }
    },[responses?.cycle]);


    return (
        <Flex padding={'10vh 10vw'} width={'100%'} height={"100%"}  justifyContent={'center'} flexDir={'column'} gap="10px" >
            <Text  textStyle="3xl" fontWeight={'bold'}>Tagihan</Text>
            <br></br>
            <br></br>
            <Flex  width={'100%'} height={"100%"} flexDir={'column'} gap={'10px'}>
                
                {cycleData.map((m, index)=>{
                    return (<div><TagihanCycle cycle={m} key={index} />  <br/> <Separator size="md"/><br/> </div>)
                })}
                
            </Flex>


            {/* {isDialogOpen?<TagihanBaru isOpen={isDialogOpen} setOpen={setDialogOpen} cycle={currCycle}/>:null} */}

        </Flex>
    );
}
export default Tagihan;


const TagihanCycle = ({cycle}) =>{


    const remainingHour = Number(cycle.hm_to)- Number(cycle.current_hm);
    const progress = (((Number(cycle.current_hm) - Number(cycle.hm_from)) / (Number(cycle.hm_to) - Number(cycle.hm_from))) * 100);
return(
                <VStack gap={'2'} alignItems={'flex-start'}>
                    <Text textStyle="xl">{cycle.rent}</Text>
                    <Flex gap={'5'}>
                     <Link textStyle={{base:"md",md:"md",}} href={`/home/unit/${cycle.machine.id}`}>{cycle.machine.name}: {cycle.hm_from}-{cycle.hm_to} HM per {Number(cycle.hm_cycle).toLocaleString('id-ID')}</Link>
                    {/* <Text >Setiap {cycle.hm_cycle} HM</Text> */}
                    </Flex>
                    <Text  >Tagihan ke: {cycle.num}</Text>
                <Progress.Root defaultValue={progress < 0 ? 0:progress} w="100%" size={'xl'} marginTop={'10px'}>
                    <HStack gap="5" >
                        <Progress.Label>{cycle.hm_from}</Progress.Label>
                        <Progress.Track flex="1">
                        <Progress.Range />
                        </Progress.Track>
                        <Progress.ValueText>{cycle.hm_to}</Progress.ValueText>
                    </HStack>
                    <Text textAlign={'center'}>{remainingHour > 0 ? `${remainingHour} Jam Lagi`:`Sudah lebih ${Math.abs(remainingHour)} Jam`} </Text>
                </Progress.Root>

                {/* <Button alignSelf={'flex-end'} onClick={(e)=>{openDialog(cycle)}}>Tutup Tagihan</Button> */}

                
                </VStack>
                
                
)    

}

// const TagihanBaru = ({isOpen, setOpen,cycle}) => {
//     const [hmAkhir, setHmAkhir] = useState(0);
//     const [hmAwal, setHmAwal] = useState(cycle?.current_hm);
//     useEffect(()=>{
//         console.log('Cycle',cycle)
//             if(hmAwal){
//             const hmTo = Number(hmAwal) + Number(cycle?.hm_cycle)
//             setHmAkhir(hmTo);
//             }
//     },[hmAwal])

//     const handleUpdateTagihan = () =>{
//         const body = {startingHm:hmAwal,number:(Number(cycle.num)+1), 
//             machineData:{id:cycle.machine.id,hm_to:hmAkhir,curr_hm:cycle.current_hm,cost_hm:cycle.cost_hm,rent:cycle.rent,hm_per_cycle:cycle.hm_cycle},
//             oldCycle:{id:cycle.id,status:cycle.status,current_hm:cycle.current_hm,cost_hm:cycle.cost_hm,total_cost:cycle.total_cost}}
            
//     }

//   return (
//     <Dialog.Root lazyMount open={isOpen} onOpenChange={(e) => setOpen(e.open)}>
//       <Dialog.Trigger asChild>
//         <Button variant="outline" size="sm">
//           Open Dialog
//         </Button>
//       </Dialog.Trigger>
//       <Portal>
//         <Dialog.Backdrop />
//         <Dialog.Positioner>
//           <Dialog.Content>
//             <Dialog.Header>
//               <Dialog.Title>Tutup Tagihan</Dialog.Title>
//             </Dialog.Header>
//             <Dialog.Body>
//                 <VStack alignItems={'flex-start'}>
//               <p>
//                 Tutup tagihan dan buat tagihan baru.
//               </p>
//               <Stack gap="4" maxW="sm" css={{ "--field-label-width": "96px" }}>
                
//                  <Field.Root orientation="horizontal">
//         <Field.Label>Unit</Field.Label>
//         <Input disabled flex="1" value={cycle?.machine?.name?cycle.machine.name:''}/>
//       </Field.Root>
//       <Field.Root orientation="horizontal">
//         <Field.Label>HM Start</Field.Label>
//         <Input  flex="1" value={hmAwal} onChange={(e)=>{setHmAwal(e.target.value)}}/>
//       </Field.Root>
//     <Field.Root orientation="horizontal">
//         <Field.Label>HM Siklus</Field.Label>
//         <Input  flex="1" value={cycle?.hm_cycle} disabled/>
//       </Field.Root>
//       <Field.Root orientation="horizontal">
//         <Field.Label>HM Akhir</Field.Label>
//         <Input disabled flex="1" value={hmAkhir}/>
//       </Field.Root>

      
//     </Stack>
//               </VStack>
//             </Dialog.Body>
//             <Dialog.Footer>
//               <Dialog.ActionTrigger asChild>
//                 <Button variant="outline">Cancel</Button>
//               </Dialog.ActionTrigger>
//               <Button>Tutup Tagihan dan Buat Baru</Button>
//             </Dialog.Footer>
//             <Dialog.CloseTrigger asChild>
//               <CloseButton size="sm" />
//             </Dialog.CloseTrigger>
//           </Dialog.Content>
//         </Dialog.Positioner>
//       </Portal>
//     </Dialog.Root>
//   )
// }

